import {
  DISABLED,
  normalizeMaintenanceConfig,
  resolveFlagUrl,
} from './maintenanceContract';

export {
  DISABLED,
  MAINTENANCE_API_PATH,
  normalizeMaintenanceConfig,
  parseUntil,
  resolveFlagUrl,
} from './maintenanceContract';

export const getMaintenanceConfig = async () => {
  try {
    const res = await fetch(resolveFlagUrl(), { cache: 'no-store' });

    if (!res.ok) {
      throw new Error(`maintenance flag responded ${res.status}`);
    }

    return normalizeMaintenanceConfig(await res.json());
  } catch (error) {
    console.error('[maintenance] failed to read flag', error);

    return DISABLED;
  }
};

// 同步可讀的最新旗標快照,給 request 層在送出前擋(Gate 每次拿到結果就更新)
let snapshot = DISABLED;

export const setMaintenanceSnapshot = (config) => {
  snapshot = config || DISABLED;
};

export const isMaintenanceActive = () => snapshot.enabled === true;
